
import React, { useState } from 'react';
import {
  AppstoreOutlined,
  BankOutlined,
  CheckSquareOutlined,
  BlockOutlined,
  ProductOutlined,
  GiftOutlined,
  UserOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import HeaderNavbar from 'components/cmslayout/HeaderNavbar';
import logo from 'assets/images/yelogo.png'; 

const { Content, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem(
    <Link to="/admin-panel">Dashboard</Link>,
    'dashboard',
    <AppstoreOutlined />
  ),
  getItem(
    <Link to="/markets">Markets</Link>,
    'markets',
    <BankOutlined />
  ),
  getItem(
    <Link to="/store-approval">Store</Link>,
    'store-approval',
    <CheckSquareOutlined />
  ),
  getItem(
    <Link to="/product-category">Product Category</Link>,
    'product-category',
    <BlockOutlined />
  ),
  getItem(
    <Link to="/admin/master-products">Master Products</Link>,
    'master-products',
    <ProductOutlined />
  ),
  getItem(
    <Link to="/admin/packages">Packages</Link>,
    'packages',
    <GiftOutlined />
  ),
  getItem(
    <Link to="/approved-vendors">Vendor</Link>,
    'approved-vendors',
    <UserOutlined />
  ),
  getItem(
    'Rep',
    'rep',
    <TeamOutlined />,
    [
      // Hidden for now. Keep the routes/pages available for later re-enablement.
      // getItem(
      //   <Link to="/rep-performance">Registration of Users by Reps</Link>,
      //   'rep-performance',
      // ),
      // getItem(
      //   <Link to="/rep-rejections">Rejections</Link>,
      //   'rep-rejections',
      // ),
      // getItem(
      //   <Link to="/rep-reviews">Reviews</Link>,
      //   'rep-reviews',
      // ),
      getItem(
        <Link to="/add-rap">Manage Reps</Link>,
        'add-rap',
      ),
    ],
  ),
];

interface HomeLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Cmslayout: React.FC<HomeLayoutProps> = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const pathToKey: Record<string, string> = {
    '/admin-panel': 'dashboard',
    '/markets': 'markets',
    '/admin/markets': 'markets',
    '/store-approval': 'store-approval',
    '/product-category': 'product-category',
    '/admin/product-category': 'product-category',
    '/master-products': 'master-products',
    '/admin/master-products': 'master-products',
    '/packages': 'packages',
    '/admin/packages': 'packages',
    '/approved-vendors': 'approved-vendors',
    '/add-rap': 'add-rap',
    '/admin/add-rap': 'add-rap',
    '/rep-performance': 'rep-performance',
    '/rep-rejections': 'rep-rejections',
    '/rep-reviews': 'rep-reviews',
    '/products': 'products',
    '/new-procurement': 'new-procurement',
  };

  const selectedKey = pathToKey[location.pathname] || 'dashboard';
  const defaultOpenKeys = selectedKey.startsWith('rep') || selectedKey === 'add-rap'
    ? ['rep']
    : [];

  return (
    <Layout style={{ minHeight: '100vh' }} className="adminpanel-layout cmslayout-dashboard">
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        className="cmslayout-sider-light"
        width={240}
      >
        <div className="cmslayout-brand">
          <img
            src={logo}
            alt="IYE Logo"
            className="cmslayout-brand-logo"
          />
        
        </div>

        <Menu
          theme="light"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={defaultOpenKeys}
          mode="inline"
          items={items}
          className="cmslayout-menu-light"
        />
      </Sider>

      <Layout>
        <HeaderNavbar />
        <Content className="cmslayout-content-wrap">
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Cmslayout;
